import React, { useRef, useState, useEffect } from 'react';
import NavBar from '../../NavBar';
import NewClassificacaoPDF from './newClassificacaoPDF';
import NewNotificacaoPDF from '../notificacao/newNotificacaoPDF.js';
import logo from '../../../images/bluelogo.png';
import { IoMdClose } from 'react-icons/io';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { GoPlus } from 'react-icons/go';
import Cookies from 'js-cookie';
import { set, z } from 'zod';
import { HiOutlineExclamationCircle } from 'react-icons/hi2';
import classificacoes from '../../../utils/classificacoes.json';

import NewNotificacaoPreenchido from '../notificacao/newNotificacaoPreenchido';

import FinishCard from '../finishCard';
import {
	requestInputsChoices,
	requestInvestigators,
	requestNewClassCreation,
} from '../../../services/newNotesRequest';
import {
	requestEmailSend,
	requestNewInvCreation,
} from '../../../services/requests'; // ← NOVO

// Schema Zod com regra condicional: neverEvent obrigatório se incidente === 'Never event'
const formSchema = z
	.object({
		classificacao: z.string().min(1, 'Selecione um incidente'),
		sub_classificacao: z.string().optional(),
		prazo_investigacao: z.string().min(1, 'Defina um prazo máximo'),
	})
	.refine(
		(data) =>
			data.classificacao !== 'NEVER_EVENTS' ||
			(data.classificacao === 'NEVER_EVENTS' &&
				!!data.sub_classificacao &&
				data.sub_classificacao.trim() !== ''),
		{
			message: 'Selecione um Never Event',
			path: ['sub_classificacao'],
		},
	)
	.superRefine((data, ctx) => {
		// impede prazo máximo anterior à data atual
		if (!data.prazo_investigacao) return;

		const [ano, mes, dia] = data.prazo_investigacao
			.split('-')
			.map((n) => Number(n));

		const prazoDate = new Date(ano, mes - 1, dia);
		const hoje = new Date();
		hoje.setHours(0, 0, 0, 0);

		if (isNaN(prazoDate.getTime())) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['prazo_investigacao'],
				message: 'Data inválida',
			});
			return;
		}

		if (prazoDate < hoje) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				path: ['prazo_investigacao'],
				message: 'O prazo deve ser posterior à data atual',
			});
		}
	});

const getClassificacaoEmailText = (classificacaoKey = '', choices = {}) => {
	const choiceValue = choices?.classificacao?.[classificacaoKey];
	const localClassificacao = classificacoes.find(
		(item) => item?.display === classificacaoKey,
	);

	const nome =
		(typeof choiceValue === 'object'
			? choiceValue?.nome || choiceValue?.label || choiceValue?.value
			: choiceValue) ||
		localClassificacao?.value ||
		classificacaoKey ||
		'Classificacao nao informada';
	const descricao =
		(typeof choiceValue === 'object'
			? choiceValue?.descricao || choiceValue?.description
			: '') ||
		localClassificacao?.descricao ||
		'Descricao nao informada';

	return `${nome} - ${descricao}`;
};

export default function NewClassificacao({ notificacao }) {
	const [openConclude, setOpenConclude] = useState(false);
	const [openSend, setOpenSend] = useState(false);
	const [invList, setInvList] = useState([]);
	const [emailError, setEmailError] = useState([]);
	const [currentEmail, setCurrentEmail] = useState([]);
	const [emailList, setEmailList] = useState([]);
	const [openAlert, setOpenAlert] = useState(false);
	const [sendVisible, setSendVisible] = useState(false);
	const [concludeLoading, setConcludeLoading] = useState(false); // NOVO
	const [sendLoading, setSendLoading] = useState(false); // NOVO

	const [currentConcludeEmail, setCurrentConcludeEmail] = useState([]);
	const [concludeList, setConcludeList] = useState([]);
	const [observacoes, setObservacoes] = useState('');
	const [concludeClass, setConcludeClass] = useState(false); // ← NOVO
	const [concludeValue, setConcludeValue] = useState(''); // ← NOVO

	const [sended, setSended] = useState(false);
	const [choices, setChoices] = useState();

	const {
		register,
		handleSubmit,
		watch,
		setValue,
		formState: { errors, isValid },
	} = useForm({
		resolver: zodResolver(formSchema),
		mode: 'onChange',
		defaultValues: {
			classificacao: '',
			sub_classificacao: '',
			prazo_investigacao: '',
		},
	});

	const classificacaoSelecionado = watch('classificacao');

	const tiposComPrazoFixo = ['GRAVE', 'OBITO', 'NEVER_EVENTS'];
	const handleChoices = async () => {
		const result = await requestInputsChoices();

		setChoices(result);
	};

	const handleInvestigadores = async () => {
		const token = Cookies.get('user')
			? JSON.parse(Cookies.get('user'))?.token
			: '';
		const protocolo = notificacao?.protocolo;
		const result = await requestInvestigators(token, protocolo);
		setInvList(result);
	};

	const addEmail = () => {
		if (currentEmail && !emailList.includes(currentEmail)) {
			setEmailList([...emailList, currentEmail]);
		}
	};
	const pdfRef = useRef(null);

	const removeEmail = (emailToRemove) => {
		setEmailList(emailList.filter((email) => email !== emailToRemove));
	};

	/* funcoes de conclusao */
	const handlefinishConclude = async () => {
		// validações básicas (igual antes)
		const hasEmails = concludeList.length > 0;
		const hasObs = observacoes && observacoes.trim().length > 0;
		const hasClassOk =
			!concludeClass || (concludeClass && concludeValue.length > 0);

		if (!hasEmails || !hasObs || !hasClassOk) return;

		setConcludeLoading(true);

		try {
			const userCookie = Cookies.get('user');
			if (!userCookie) {
				setConcludeLoading(false);
				return;
			}
			const { token } = JSON.parse(userCookie);
			if (!token) {
				setConcludeLoading(false);
				return;
			}

			const payloadClass = {
				classificacao:
					concludeClass && concludeValue.length > 0
						? concludeValue
						: '',
				sub_classificacao: '',
				descartar: true,
				justificativa_descarte: observacoes,
				investigadores_lista: [],
				prazo_investigacao: null,
				protocolo: notificacao.protocolo,
			};

			const payloadEmail = {
				template_id: 3,
				destinatarios: concludeList,
				variaveis: {
					protocolo: notificacao.protocolo,
					observacao: observacoes,
					unidade: notificacao?.unidade_nome
						? notificacao.unidade_nome
						: 'unidade não informada',
				},
			};

			const [, classRes] = await Promise.all([
				requestEmailSend(token, payloadEmail).catch((err) => {
					console.error('Erro ao enviar e-mail de conclusão:', err);
				}),
				requestNewClassCreation(token, payloadClass),
			]);

			// mesmo que o e-mail falhe, se a API de conclusão respondeu, seguimos para a tela de sucesso
			if (!classRes || classRes.error) {
				console.error('Erro ao concluir notificação:', classRes);
				// ainda assim fecha fluxo visual, como solicitado
			}

			setOpenAlert(false);
			setOpenConclude(false);
			setSended(true); // vai para o FinishCard
		} catch (err) {
			console.error('Erro na conclusão:', err);
		} finally {
			setConcludeLoading(false);
		}
	};

	// NOVO: função de envio para investigação (usada no modal "Enviar para o investigador")
	const handleFinishSend = async () => {
		const userCookie = Cookies.get('user');
		if (!userCookie) return;

		const { token } = JSON.parse(userCookie);
		if (!token) return;

		setSendLoading(true); // inicia loading

		try {
			// monta objeto a partir dos valores atuais do formulário
			let object;
			if (
				['NEVER_EVENTS', 'OBITO', 'GRAVE'].some((item) =>
					watch().classificacao?.includes(item),
				)
			) {
				object = {
					classificacao: watch().classificacao,
					sub_classificacao: Object.keys(
						choices?.sub_classificacao || {},
					).find(
						(k) =>
							choices.sub_classificacao[k]?.codigo ===
							watch().sub_classificacao,
					),
				};
			} else {
				object = watch();
			}

			const selectedInvestigadores = invList.filter((item) =>
				emailList.includes(item.email),
			);
			const selectedInvestigatorEmails = selectedInvestigadores
				.map((item) => item.email)
				.filter(Boolean);
			const prazoInvestigacao = watch().prazo_investigacao;
			const classificacaoEmail = getClassificacaoEmailText(
				watch().classificacao,
				choices,
			);

			const result = await requestNewClassCreation(token, {
				...object,
				protocolo: notificacao.protocolo,
				descartar: false,
				justificativa_descarte: '',
				investigadores_lista: selectedInvestigadores.map(
					(item) => item.username,
				),
			});

			if (!result.error) {
				// assim que a classificação é criada com sucesso,
				// iniciamos também a investigação correspondente
				try {
					await Promise.all([
						requestNewInvCreation(token, notificacao.protocolo),
						requestEmailSend(token, {
							template_id: 2,
							destinatarios: selectedInvestigatorEmails,
							variaveis: {
								protocolo: notificacao.protocolo,
								classificacao: classificacaoEmail,
								prazo: prazoInvestigacao,
								unidade: notificacao?.unidade_nome
									? notificacao.unidade_nome
									: 'unidade nao informada',
							},
						}).catch((emailError) => {
							console.error(
								'Erro ao enviar e-mail para investigadores:',
								emailError,
							);
						}),
					]);
				} catch (e) {
					console.error(
						'Erro ao iniciar investigação após classificação:',
						e,
					);
				}

				setSended(true);
				setSendVisible(false);
				setOpenSend(false);
			}
		} catch (err) {
			console.error('Erro ao enviar para investigação:', err);
		} finally {
			setSendLoading(false); // encerra loading mesmo em erro
		}
	};

	const handleConcludeEmail = (email) => {
		setCurrentConcludeEmail(email);
	};

	const handleObservacoes = (valor) => {
		setObservacoes(valor);
	};

	const addConcludeEmail = () => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!currentConcludeEmail || !emailRegex.test(currentConcludeEmail)) {
			setEmailError('Email invalido');
			return;
		}

		if (!concludeList.includes(currentConcludeEmail)) {
			setConcludeList([...concludeList, currentConcludeEmail]);
			setEmailError(null); // limpa o erro caso tenha sido válido
		}
	};

	const removeConcludeEmail = (emailToRemove) => {
		setConcludeList(
			concludeList.filter((email) => email !== emailToRemove),
		);
	};

	// ajusta prazo quando classificacao mudar:
	useEffect(() => {
		handleChoices();
		if (tiposComPrazoFixo.includes(classificacaoSelecionado)) {
			const dataAtual = new Date();
			dataAtual.setDate(dataAtual.getDate() + 2);
			const dataFormatada = dataAtual.toISOString().split('T')[0]; // YYYY-MM-DD
			setValue('prazo_investigacao', dataFormatada, {
				shouldValidate: true,
				shouldDirty: true,
			});
			// se Never event, neverEvent continuará obrigatorio via schema/refine
		} else {
			// classificacao NORMAL: remove preset e permite edição pelo usuário
			setValue('prazo_investigacao', '', { shouldValidate: true });
			// também limpa neverEvent caso queira (opcional). Mantive como '' para evitar obrigatoriedade.
			setValue('sub_classificacao', '', { shouldValidate: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [classificacaoSelecionado, setValue]);

	const onSubmit = (data) => {
		handleInvestigadores();
		setOpenSend(true);
		setTimeout(() => setSendVisible(true), 10); // pequeno delay para o CSS transition pegar
	};

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />

			{sended ? (
				<FinishCard
					stage='classificacao'
					requestResult={{
						notificacao: notificacao,
						classificacao: watch(),
					}}
				/>
			) : (
				<div className='flex-1 font-inter'>
					<div className='mt-[80px] w-[90%] sm:w-[95%] max-w-[1136px] mx-auto flex items-center justify-center flex-col'>
						<div className='gap-[32px] flex flex-col  w-full'>
							{/* TITULO */}
							<div className='bg-[#F0F4F8] flex rounded-sm w-full content-center min-h-[142px] p-[32px] gap-[30px] justify-between lg:flex-row flex-col'>
								<div className='content-center items-center mx-auto'>
									<img
										className='w-[200px]  sm:w-[300px] h-auto'
										src={logo}
										alt='logo'></img>
								</div>
								<p className='text-[28px] sm:text-[32px] font-bold text-[#13335A] content-center  max-w-[714px] text-center'>
									NOTIFICAÇÃO DE INCIDENTES E NÃO
									CONFORMIDADES
								</p>
							</div>
							{/* FORMULARIO */}
							<NewNotificacaoPreenchido
								notificacao={notificacao}
							/>
							<div
								ref={pdfRef}
								style={{
									position: 'absolute',
									left: '-9999px',
									top: 0,
								}}>
								<NewNotificacaoPDF notificacao={notificacao} />
								<NewClassificacaoPDF
									notificacao={notificacao}
								/>
							</div>
							{}
							<form
								onSubmit={handleSubmit(onSubmit)}
								className='w-full  mx-auto  bg-white flex flex-col gap-[30px]'>
								{/* CLASSIFICAÇÃO */}
								<div className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md'>
									{/* TITULO */}
									<p className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold font-inter border-[#E3E3E3] border-b-[1px] py-1'>
										CLASSIFICAÇÃO DO INCIDENTE
									</p>
									<div className='p-3 w-full'>
										<p className='text-[#004A80] font-medium'>
											Classificação
										</p>
										<select
											{...register('classificacao')}
											className='border-[1px] rounded-md border-[#E3E3E3] py-1 px-2 text-[#868686] placeholder:[#757575] h-[40px] w-full'>
											<option value=''>
												{' '}
												Selecione a classificação{' '}
											</option>
											{choices?.classificacao &&
												Object.entries(
													choices.classificacao,
												)
													.filter(
														([value]) =>
															value !== 'OUTRA_NATUREZA',
													)
													.map(([value, item]) => (
													<option
														key={
															value + '-classificacao'
														}
														value={value}
														title={item} // 🔹 tooltip nativo do navegador
													>
														{item.length > 100
															? item.slice(
																	0,
																	130,
																) + '...'
															: item}
													</option>
												))}

											{/* 	<option value=''>
											{' '}
											Selecione o incidente{' '}
										</option>
										<option value='Normal'> Normal </option>
										<option value='Grave'> Grave </option>
										<option value='Óbito'> Óbito </option>
										<option value='Never event'>
											{' '}
											Never event{' '}
										</option> */}
										</select>

										{errors.classificacao && (
											<p className='text-red-500 text-sm'>
												{errors.classificacao.message}
											</p>
										)}
									</div>

									{classificacaoSelecionado.includes(
										'NEVER_EVENTS',
									) && (
										<div className='h-[1px] w-[97.5%] mx-auto bg-[#E3E3E3]'></div>
									)}

									{/* Never Event (só aparece se for classificacao Never event) */}

									{classificacaoSelecionado.includes(
										'NEVER_EVENTS',
									) && (
										<div className='p-3 w-full'>
											<p className='text-[#004A80] font-medium'>
												Never Event
											</p>
											<select
												{...register(
													'sub_classificacao',
												)}
												className='border-[1px] rounded-md border-[#E3E3E3] py-1 px-2 text-[#868686] placeholder:[#757575] h-[40px] w-full'>
												<option value=''>
													{' '}
													Selecione o never event{' '}
												</option>

												{Object.values(
													choices?.sub_classificacao,
												).map((item, index) => (
													<option
														key={
															item +
															index +
															'nunca eventos'
														}
														value={item?.codigo}>
														{' '}
														{item.nome}{' '}
													</option>
												))}
											</select>
											{errors.sub_classificacao && (
												<p className='text-red-500 text-sm'>
													{
														errors.sub_classificacao
															.message
													}
												</p>
											)}
										</div>
									)}
								</div>

								<div className='flex flex-col border-[1px] border-[#E3E3E3] rounded-md'>
									{/* TITULO */}
									<div className='text-[#004A80] bg-[#F4F4F4] rounded-t-md text-[18px] text-center font-semibold font-inter py-1 border-[#E3E3E3] border-b-[1px]'>
										ANÁLISE DO INCIDENTE
										<p className='text-[16px] font-normal'>
											Preenchido pelo Núcleo de Segurança
											do Paciente
										</p>{' '}
									</div>
									<div className='p-3 w-full items-start sm:flex gap-3 sm:items-center'>
										<p className='text-[#004A80] font-medium'>
											Prazo máximo para a conclusão da
											investigação
										</p>
										<input
											type='date'
											min={
												new Date()
													.toISOString()
													.split('T')[0]
											}
											{...register('prazo_investigacao')}
											readOnly={tiposComPrazoFixo.includes(
												classificacaoSelecionado,
											)}
											className='border-[1px] rounded-md text-[#9c9c9c] border-[#E3E3E3] py-1 px-2 placeholder:[#757575] h-[40px]'></input>
										{errors.prazo_investigacao && (
											<p className='text-red-500 text-sm'>
												{
													errors.prazo_investigacao
														.message
												}
											</p>
										)}
									</div>
								</div>

								{/* BOTÕES */}
								<div className='w-full  flex'>
									<div
										className={`w-full rounded-[4px] flex flex-col gap-5 sm:gap-0 sm:flex-row  justify-between`}>
										<button
											type='button'
											onClick={() => {
												setOpenConclude(true);
											}}
											className='text-[#757575] border-[1px] hover:bg-[#fafafa] border-[#E3E3E3] rounded-[4px] w-[330px] font-inter p-[8px]'>
											Encerrar notificação
										</button>
										{/* O botão só habilita quando isValid === true */}
										<button
											type='submit'
											className={`text-[#757575] border-[1px] border-[#E3E3E3] rounded-[4px] hover:border-[#d6d6d6] hover:bg-[#fafafa] w-[330px] font-inter p-[8px] ${
												!isValid
													? 'opacity-50 cursor-not-allowed'
													: ''
											}`}
											disabled={!isValid}>
											Enviar para investigação
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
			{/* Modal Conclude (mantive seu layout) */}
			{openConclude && (
				<div className='fixed inset-0 flex items-center justify-center bg-black/40 z-50'>
					{/* alrta de confirmação */}
					{openAlert && (
						<div className='absolute z-40 rounded-md p-4 border-[1px] border-[#e9e9e9] w-[450px] gap-[20px]  text-[#757575] bg-white flex flex-col justify-center items-center'>
							<div className='flex justify-center flex-col items-center gap-[15px] w-full'>
								<HiOutlineExclamationCircle className='text-[#B74644] w-[100px] h-auto' />
								<p className='text-[#B74644] font-semibold text-[24px]'>
									ATENÇÃO!
								</p>
								<p className='text-[#757575] text-[18px] text-center'>
									Você irá concluir a notificação, deseja
									fazer isto?
								</p>
								<div className='flex gap-10 justify-center w-full mt-2'>
									<button
										type='button'
										disabled={concludeLoading}
										onClick={() =>
											!concludeLoading &&
											setOpenAlert(false)
										}
										className={`text-[#757575] border-[1px] border-[#e9e9e9] rounded-[4px] min-w-[190px] font-inter p-[8px] transition-all duration-300 ${
											concludeLoading
												? 'opacity-50 cursor-not-allowed'
												: 'hover:bg-[#d4d4d4] hover:text-white'
										}`}>
										Cancelar
									</button>
									<button
										type='button'
										disabled={concludeLoading}
										onClick={handlefinishConclude}
										className={`text-[#757575] border-[1px] border-[#e9e9e9] rounded-[4px] min-w-[190px] font-inter p-[8px] flex items-center justify-center gap-2 transition-all duration-300 ${
											concludeLoading
												? 'opacity-70 cursor-wait bg-[#004A80] border-[#004A80] text-white'
												: 'hover:bg-[#004A80] hover:border-[#004A80] hover:text-white'
										}`}>
										{concludeLoading ? (
											<>
												<span className='inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full animate-spin' />
												<span>Encerrando...</span>
											</>
										) : (
											<span>Encerrar notificação</span>
										)}
									</button>
								</div>
							</div>
						</div>
					)}

					<div
						className='absolute  inset-0'
						onClick={() => {
							setObservacoes('');
							setConcludeList([]);
							setConcludeClass(false);
							setConcludeValue('');
							setOpenConclude(false);
						}}
					/>
					<div
						className={`relative z-10 font-inter w-[80%] max-w-[450px] transition-all duration-400  p-[10px] border-[1px] border-[#E3E3E3] ${
							openAlert ? 'h-[100px]' : ''
						} rounded-[4px] flex flex-col justify-center bg-white ${
							openConclude ? 'gap-[10px]' : ''
						}`}>
						<div className='w-full flex justify-end inset-0 hover:text-[#868686] transition-all duration-300 text-[#aaaaaa]'>
							<button
								onClick={() => {
									setCurrentConcludeEmail([]);
									setObservacoes('');
									setConcludeList([]);
									setConcludeClass(false);
									setConcludeValue('');
									setOpenConclude(false);
								}}>
								<IoMdClose
									className={`transition-all duration-300 ${
										openConclude ? 'h-[20px] w-auto' : 'h-0'
									}`}
								/>
							</button>
						</div>
						<div className='text-center sm:mb-1'>
							<p className='text-3xl text-[#004A80] mx-auto font-semibold'>
								Encerrar Notificação
							</p>
							<p className='text-md max-w-[400px] mx-auto text-[#b6b6b6] font-normal'>
								preencha o formulario e finalize a notificação
								sem passar pela investigação.
							</p>
						</div>

						<div className='h-[5px] w-full bg-[]'></div>

						<div
							className={`text-[#757575] border-[#E3E3E3] rounded-[4px] font-inter w-full transition-all text-[15px] overflow-y-hidden flex flex-col duration-500 ${
								openConclude
									? 'h-[120px] gap-[5px] px-[12px] py-[8px] border-[1px]'
									: 'h-0 w-0'
							}`}>
							<p>Observação:</p>

							<textarea
								onChange={(e) =>
									handleObservacoes(e.target.value)
								}
								className='text-[15px] w-full focus:outline-none focus:ring-0 resize-none placeholder:text-[#E3E3E3]'
								placeholder='Insira sua observação aqui'
								value={observacoes}
							/>
						</div>
						<div
							className={`text-[#757575] rounded-[4px] font-inter w-full transition-all text-[15px] overflow-y-hidden duration-500 ${
								openConclude ? 'h-auto' : 'h-0 w-0'
							}`}>
							<p>Encaminhar para:</p>

							<div className='flex content-center items-center align-middle gap-2'>
								<input
									onChange={(e) => {
										handleConcludeEmail(e.target.value);
									}}
									className='text-[15px] w-full focus:outline-none focus:ring-0 resize-none placeholder:text-[#E3E3E3] border-[#E3E3E3] border-[1px] rounded-[4px] h-[40px] px-[12px] py-[8px] '
									placeholder='Digite o email'></input>

								<button
									onClick={() => addConcludeEmail()}
									className={`border-[1px] rounded-[8px] w-[30px] h-[30px] flex items-center justify-center transition-all duration-300
										${
											/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
												currentConcludeEmail,
											)
												? 'bg-[#004A80] border-[#004A80] text-white hover:bg-[#193b53] hover:border-[#193b53]'
												: 'border-[#E3E3E3]  hover:bg-[#E3E3E3] hover:text-white'
										}`}>
									<GoPlus className='w-[20px] h-[20px]' />
								</button>
							</div>
							<p className='text-red-700 text-sm'>{emailError}</p>
						</div>

						{/* lista de e-mails adicionados */}
						<div className='flex flex-wrap gap-2 max-h-[100px] overflow-auto  px-1 text-[12px] text-[#004A80]'>
							{concludeList.map((item, index) => (
								<div
									className='flex gap-1 bg-[#F4F4F4] py-1 px-2 rounded-[8px] border border-[#E3E3E3]'
									key={index + item + 'fila'}>
									{item}
									<button
										onClick={() => {
											removeConcludeEmail(item);
										}}
										className='flex justify-center items-center text-[#B74644] bg-[#FCFCFC] hover:bg-[#e6e6e6] border border-gray-200 w-[20px] h-[20px] text-[14px] rounded-md'>
										<IoMdClose />
									</button>
								</div>
							))}
						</div>

						{/* NOVO: seleção de classificação final, mesma regra do ClassInvForm */}
						<div
							className={`text-[#757575] rounded-[4px] font-inter w-full transition-all text-[15px] overflow-y-hidden duration-500 ${
								openConclude
									? 'h-auto mt-2 px-[12px]'
									: 'h-0 w-0'
							}`}>
							<p className='mb-1'>
								Deseja acrescentar classificação?
							</p>
							<div className='flex gap-4 mb-2 text-sm'>
								<label className='flex items-center gap-1'>
									<input
										type='radio'
										name='conclude-class-radio'
										id='sim'
										checked={concludeClass === true}
										onChange={() => {
											setConcludeClass(true);
											setConcludeValue('');
										}}
									/>
									<span>Sim</span>
								</label>
								<label className='flex items-center gap-1'>
									<input
										type='radio'
										name='conclude-class-radio'
										id='nao'
										checked={concludeClass === false}
										onChange={() => {
											setConcludeClass(false);
											setConcludeValue('');
										}}
									/>
									<span>Não</span>
								</label>
							</div>

							{concludeClass && (
								<div className='flex flex-col gap-1 text-sm text-[#757575]'>
									<label className='flex items-center gap-2'>
										<input
											type='radio'
											name='class-conclude'
											id='CIRCUNSTANCIA_DE_RISCO'
											checked={
												concludeValue ===
												'CIRCUNSTANCIA_DE_RISCO'
											}
											onChange={(e) =>
												setConcludeValue(e.target.id)
											}
										/>
										<p className='font-semibold'>
											Circunstância de risco
										</p>
									</label>
									<label className='flex items-center gap-2'>
										<input
											type='radio'
											name='class-conclude'
											id='NEAR_MISS'
											checked={
												concludeValue === 'NEAR_MISS'
											}
											onChange={(e) =>
												setConcludeValue(e.target.id)
											}
										/>
										<p className='font-semibold'>
											Near miss
										</p>
									</label>
									<label className='flex items-center gap-2'>
										<input
											type='radio'
											name='class-conclude'
											id='NENHUM'
											checked={concludeValue === 'NENHUM'}
											onChange={(e) =>
												setConcludeValue(e.target.id)
											}
										/>
										<p className='font-semibold'>Nenhum</p>
									</label>
								</div>
							)}
						</div>

						<button
							type='submit'
							onClick={() => setOpenAlert(true)}
							disabled={
								observacoes.length < 3 ||
								concludeList.length < 1 ||
								(concludeClass && !concludeValue)
							}
							className={` mx-auto border-[1px]  my-4 rounded-[4px]
							transition-all duration-300
							${
								concludeList.length > 0 &&
								observacoes.length > 0 &&
								(!concludeClass || concludeValue.length > 0)
									? 'text-white border-[#004A80] bg-[#004A80] hover:bg-[#193b53] hover:border-[#193b53]'
									: 'text-[#b1b1b1] border-[#E3E3E3]'
							}
							
							w-[100%] max-w-[330px] font-inter p-[8px] `}>
							Concluir Notificação
						</button>
						<div className='bg-[#004A80] h-[8px] rounded-md rounded-t-none w-full'></div>
					</div>
				</div>
			)}

			{/* Modal Send  */}
			{openSend && (
				<div className='fixed inset-0 flex items-center justify-center bg-black/40 z-50'>
					{/* alrta de confirmação */}
					{openAlert && (
						<div className='absolute z-40 rounded-md p-4 border-[1px] border-[#e9e9e9] w-[450px] gap-[20px]  text-[#757575] bg-white flex flex-col justify-center items-center'>
							<div className='flex justify-center flex-col items-center gap-[15px] w-full'>
								<HiOutlineExclamationCircle className='text-[#B74644] w-[100px] h-auto' />
								<p className='text-[#B74644] font-semibold text-[24px]'>
									ATENÇÃO!
								</p>
								<p className='text-[#757575] text-[18px] text-center'>
									Você irá encerrar a notificação, deseja
									fazer isto?
								</p>
								<div className='flex gap-10 justify-center w-full mt-2'>
									<button
										type='button'
										disabled={sendLoading}
										onClick={() =>
											!sendLoading && setOpenAlert(false)
										}
										className={`text-[#757575] border-[1px] border-[#e9e9e9] rounded-[4px] min-w-[190px] font-inter p-[8px] transition-all duration-300 ${
											sendLoading
												? 'opacity-50 cursor-not-allowed'
												: 'hover:bg-[#d4d4d4] hover:text-white'
										}`}>
										Cancelar
									</button>
									<button
										type='button'
										disabled={sendLoading}
										onClick={handleFinishSend}
										className={`text-[#757575] border-[1px] border-[#e9e9e9] rounded-[4px] min-w-[190px] font-inter p-[8px] flex items-center justify-center gap-2 transition-all duration-300 ${
											sendLoading
												? 'opacity-70 cursor-wait bg-[#004A80] border-[#004A80] text-white'
												: 'hover:bg-[#004A80] hover:border-[#004A80] hover:text-white'
										}`}>
										{sendLoading ? (
											<>
												<span className='inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full animate-spin' />
												<span>Enviando...</span>
											</>
										) : (
											<span>Encerrar notificação</span>
										)}
									</button>
								</div>
							</div>
						</div>
					)}

					<div
						className='absolute  inset-0'
						onClick={() => {
							if (sendLoading) return;
							setSendVisible(false);
							setTimeout(() => setOpenSend(false), 300);
						}}
					/>
					<div
						className={`relative z-10 w-[80%] max-w-[450px] p-[10px] border-[1px] border-[#E3E3E3] rounded-[8px] flex flex-col justify-center bg-white transition-all duration-300 ease-out
							${sendVisible ? 'opacity-100 scale-100' : 'opacity-80 scale-0'}
							${openSend ? 'gap-[10px]' : ''}`}>
						<div className='w-full flex justify-end hover:text-[#494949] transition-all duration-300 text-[#757575]'>
							<button
								onClick={() => {
									if (sendLoading) return;
									setSendVisible(false);
									setTimeout(() => setOpenSend(false), 300);
								}}>
								<IoMdClose
									className={`transition-all duration-100 hover:text-gray-400 ${
										openSend ? 'h-[20px]' : 'h-0'
									}`}
								/>
							</button>
						</div>
						<div className='text-center mb-4'>
							<p className='text-3xl text-[#004A80] mx-auto font-semibold'>
								Enviar para o investigador
							</p>
							<p className='text-sm max-w-[300px] mx-auto text-[#b6b6b6] font-normal'>
								preencha o formulário e envie a notificação para
								a próxima etapa.
							</p>
						</div>
						<div
							className={`text-[#757575] rounded-[4px] font-inter w-full transition-all text-[15px] overflow-y-hidden duration-500 ${
								openSend ? 'h-[70px] ' : 'h-0 w-0'
							}`}>
							<p>Encaminhar para:</p>
							<div className='flex content-center items-center align-middle gap-2'>
								<select
									onChange={(e) =>
										setCurrentEmail(e.target.value)
									}
									disabled={sendLoading}
									className='text-[15px] w-full focus:outline-none focus:ring-0 resize-none placeholder:text-[#E3E3E3] border-[#E3E3E3] border-[1px] rounded-[4px] px-[12px] py-[8px] h-[40px]'
									placeholder='Digite o email'>
									<option value=''>
										Selecione o investigador
									</option>

									{invList?.map((item, index) => (
										<option
											key={
												item +
												index +
												'emailInvestigador'
											}
											value={item.email}>
											{item.nome}
										</option>
									))}
								</select>
								<button
									onClick={() => addEmail()}
									disabled={
										currentEmail.length < 1 || sendLoading
									}
									className={` border-[1px] rounded-[8px] w-[30px] h-[30px] flex items-center justify-center transition-all duration-200   ${
										currentEmail.length > 1 && !sendLoading
											? 'bg-[#004A80] border-[#004A80] hover:bg-[#1a3c55] hover:border-[#1a3c55] text-white font-semibold'
											: 'border-[#E3E3E3] hover:bg-[#E3E3E3] hover:text-white'
									}`}>
									<GoPlus className=' w-[18px] h-[18px]' />
								</button>
							</div>
						</div>
						<div className='flex flex-wrap gap-2  px-1 text-[12px] text-[#004A80]'>
							{emailList.map((item, index) => (
								<div
									className='flex gap-1 bg-[#F4F4F4] py-1 px-2 rounded-[8px] border border-[#E3E3E3]'
									key={index + item + 'fila'}>
									{item}
									<button
										onClick={() => {
											if (sendLoading) return;
											removeEmail(item);
										}}
										className='flex justify-center items-center text-[#B74644] bg-[#FCFCFC] hover:bg-[#e6e6e6] border border-gray-200 w-[20px] h-[20px] text-[14px] rounded-md'>
										<IoMdClose />
									</button>
								</div>
							))}
						</div>
						<button
							type='submit'
							onClick={() => {
								if (!sendLoading) handleFinishSend();
							}}
							disabled={emailList.length < 1 || sendLoading}
							className={`text-[#757575] transition-all duration-300 mx-auto border-[1px] mt-10 border-[#E3E3E3] my-4 rounded-[4px] w-[330px] font-inter p-[8px] flex items-center justify-center gap-2
							${
								emailList.length > 0 && !sendLoading
									? 'enabled:text-white enabled:bg-[#004A80] enabled:border-[#004A80] enabled:hover:text-[#ffffff] enabled:hover:bg-[#1c425e] enabled:hover:border-[#1c425e]'
									: 'opacity-50 cursor-not-allowed'
							}`}>
							{sendLoading ? (
								<>
									<svg
										aria-hidden='true'
										className='w-5 h-5 text-gray-200 animate-spin fill-blue-600'
										viewBox='0 0 100 101'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'>
										<path
											d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
											fill='currentColor'
										/>
										<path
											d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
											fill='currentFill'
										/>
									</svg>
									<span>Enviando...</span>
								</>
							) : (
								'Enviar para investigação'
							)}
						</button>
						<div className='bg-[#004A80] h-[8px] rounded-md rounded-t-none w-full'></div>
					</div>
				</div>
			)}
		</div>
	);
}
